import BreadCardModule from './BreadCardModule';

export default BreadCardModule;
